import Box from "@mui/material/Box";
import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import { enqueueSnackbar } from "notistack";

import { FILE_SIZE } from "components/constants";
import { SvgIconProps, Typography } from "@mui/material";
import { doesUserHaveCustomerId } from "api/firebase/stripe";
import { checkUserSubscription } from "api/stripe";
import { useUser } from "hooks/users";
import { useNavigate } from "react-router-dom";
import { getUserFreeTrialStatus } from "services/user";

interface DropzoneProps {
  Icon?: React.FC<SvgIconProps>;
  message: string;
  setFiles: React.Dispatch<React.SetStateAction<File[]>>;
  setIsDrawerOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function Dropzone({
  Icon,
  message,
  setFiles,
  setIsDrawerOpen,
}: DropzoneProps) {
  const [disabled, setDisabled] = useState(true);

  const navigate = useNavigate();
  const user = useUser();

 

  useEffect(() => {
    const checkUserStatus = async () => {
    
      const firstTime = await getUserFreeTrialStatus(user!.uid);

      
      if (firstTime) {
        setDisabled(false);
        return;
      }
  
      const { customerId } = await doesUserHaveCustomerId(user);
      if (!customerId) {
        setDisabled(true);
      } else {
        const { doesUserHaveActiveSubscription } = await checkUserSubscription({
          customerId,
        });
        setDisabled(!doesUserHaveActiveSubscription);
      }
    };
  
    if (user) checkUserStatus();
  }, [user]);
  const { getRootProps, getInputProps } = useDropzone({
    onDropAccepted: (files) => {
      if (disabled) {
        enqueueSnackbar("Upgrade or renew your plan for unlimited use", {
          variant: "error",
          autoHideDuration: 5000,
        });
        navigate("/settings/payment-settings")
      } else {
        setIsDrawerOpen?.(true);
        setFiles(files);
      }
    },
    onDropRejected: () => {
      enqueueSnackbar("File too large", {
        variant: "error",
        autoHideDuration: 3000,
      });
    },
    maxSize: FILE_SIZE.MAX,
  });

  return (
    <Box
      {...getRootProps({ className: "dropzone" })}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "2px dashed #bbb",
        height: "100%",
        borderRadius: 2,
        mx: "auto",
        p: 4,
        textAlign: "center",
        fontSize: "1.5rem",
        fontWeight: 700,
        color: "#000",
        outline: "none",
        transition: ".1s ease-in-out",
        "&:hover": {
          borderColor: "#333",
          backgroundColor: "#eee",
        },
      }}
    >
      <Box component={"input"} {...getInputProps()} />
      {Icon ? <Icon /> : null}
      <Typography>{message}</Typography>
    </Box>
  );
}
